// extracted by mini-css-extract-plugin
module.exports = {"BoxCard":"BoxCard_BoxCard__dKEEj","ImageBox":"BoxCard_ImageBox__3RHfa","Pricing":"BoxCard_Pricing__2jeJO","Description":"BoxCard_Description__FmkpA"};